import type { ColumnDefinition, PresetConfiguration } from '@/components/column-configurator-modal';

// Cost Budget Column Definitions
export const COST_BUDGET_COLUMNS: ColumnDefinition[] = [
  {
    id: 'category',
    name: 'Category',
    description: 'Cost category name',
    category: 'Financial',
    visible: true,
    locked: true,
    order: 0,
  },
  {
    id: 'budget',
    name: 'Budget (£)',
    description: 'Budgeted amount for this category',
    category: 'Financial',
    visible: true,
    order: 1,
    align: 'right',
  },
  {
    id: 'actual',
    name: 'Actual (£)',
    description: 'Costs incurred to date',
    category: 'Financial',
    visible: true,
    order: 2,
    align: 'right',
  },
  {
    id: 'committed',
    name: 'Committed (£)',
    description: 'Approved purchase orders not yet invoiced',
    category: 'Financial',
    visible: true,
    order: 3,
    align: 'right',
  },
  {
    id: 'remaining',
    name: 'Remaining (£)',
    description: 'Budget remaining (Budget - Actual - Committed)',
    category: 'Financial',
    visible: true,
    order: 4,
    align: 'right',
  },
  {
    id: 'percent-used',
    name: '% Used',
    description: 'Percentage of budget consumed',
    category: 'Performance',
    visible: true,
    order: 5,
    align: 'right',
  },
  {
    id: 'status',
    name: 'Status',
    description: 'Budget health status indicator',
    category: 'Status',
    visible: true,
    order: 6,
  },
];

// Cost Budget Preset Configurations
export const COST_BUDGET_PRESETS: PresetConfiguration[] = [
  {
    id: 'default',
    name: 'Default View',
    columns: [
      { id: 'category', visible: true },
      { id: 'budget', visible: true },
      { id: 'actual', visible: true },
      { id: 'committed', visible: true },
      { id: 'remaining', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'financial-summary',
    name: 'Financial Summary',
    columns: [
      { id: 'category', visible: true },
      { id: 'budget', visible: true },
      { id: 'actual', visible: true },
      { id: 'remaining', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'commitment-tracking',
    name: 'Commitment Tracking',
    columns: [
      { id: 'category', visible: true },
      { id: 'budget', visible: true },
      { id: 'actual', visible: true },
      { id: 'committed', visible: true },
      { id: 'remaining', visible: true },
      { id: 'percent-used', visible: true },
    ],
  },
  {
    id: 'compact',
    name: 'Compact View',
    columns: [
      { id: 'category', visible: true },
      { id: 'budget', visible: true },
      { id: 'actual', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'status', visible: true },
    ],
  },
];

// Storage key for cost budget column preferences
export const COST_BUDGET_STORAGE_KEY = 'cost-budget-column-preferences-v1';
